<template>
  <div class="visual-atmosphere" aria-hidden="true">
    <div class="atmosphere-beam" />
    <div class="atmosphere-orbit" />
    <div class="atmosphere-grain" />
  </div>
</template>

<script>
export default { name: 'VisualAtmosphere' }
</script>
